<template>
  <v-app id="inspire">
    <v-navigation-drawer app clipped v-model="navBar">
      <v-list>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="/sin-perfil.jpg" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ $store.state.user.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list dense>
        <v-list-item
          color="green"
          to="/dashboard"
          @click="clearNavigation"
          link
          value="true"
        >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list dense>
        <v-list-group
          v-for="menu in menus"
          :key="menu.id"
          v-model="menu.active"
          prepend-icon="mdi-folder"
          color="green"
          v-show="menu.links"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="menu.name"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            @click="clearNavigation"
            :to="link.path"
            v-for="link in menu.links"
            :key="link.id"
          >
            <v-list-item-icon>
              <v-icon>mdi-{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="link.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          @click="clearNavigation"
          :to="menu.path"
          :key="menu.id"
          v-for="menu in menus"
          v-show="!menu.links"
        >
          <v-list-item-icon>
            <v-icon>mdi-{{ menu.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="menu.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="#97cf72" dark app clipped-left>
      <v-app-bar-nav-icon @click.stop="navBar = !navBar"></v-app-bar-nav-icon>
      <v-spacer />
      <v-toolbar-title>
        <img src="/logo.png" style="width: 150px" />
      </v-toolbar-title>
      <v-spacer />
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col>
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    menus: {},
    navBar: null,
  }),
  methods: {
    clearNavigation() {
      for (var menu in this.menus) {
        if (this.menus[menu].links) {
          for (var link in this.menus[menu].links) {
            if (this.menus[menu]["links"][link].path == this.$route.path) {
              this.menus[menu]["links"][link].active = true;
              this.menus[menu].active = true;
              break;
            } else {
              this.menus[menu]["links"][link].active = false;
              this.menus[menu].active = false;
            }
          }
        }
      }
    },
    getMenus() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(this.$store.state.apiUrl + "menus");
        request
          .then(({ data }) => {
            this.menus = data;
            this.clearNavigation();
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
    logout() {
      this.openLoader();
      window.setTimeout(() => {
        const peticion = this.sendRequest(
          this.$store.state.apiUrl + "logout",
          {},
          "POST"
        );
        peticion
          .then(() => {
            window.location = "/login";
          })
          .catch(() => this.closeLoader());
      }, 200);
    },
  },
  beforeMount() {
    this.getMenus();
  },
};
</script>